import { Skeleton } from '@progress/kendo-react-indicators';
import styles from './Skeletons.module.css';

/**
 * Visual placeholder shown in place of the document preview while the
 * document URL is being fetched (initial load only — switching between
 * already-fetched documents reuses the cached preview without flickering
 * a skeleton in between). Mimics the breadcrumb header + content area of
 * `DocumentsViewer`.
 */
const DocumentViewerSkeleton = () => (
  <div className={styles['viewer-skeleton']} role="status" aria-label="Loading document">
    <div className={styles['viewer-skeleton-header']}>
      <Skeleton shape="text" style={{ width: '60%', height: 16 }} />
      <Skeleton shape="rectangle" style={{ width: 32, height: 32, borderRadius: 4 }} />
    </div>
    <div className={styles['viewer-skeleton-body']}>
      <Skeleton shape="rectangle" style={{ width: '100%', height: '100%' }} />
    </div>
  </div>
);

export default DocumentViewerSkeleton;
